import { type ExperimentValue } from '@stone-payments/experiment/src/lib/types'

export type SweepAccountsAboutQuestion = {
  title: string
  description: string
  type?: string
}

export type SweepAccountsAboutContent = {
  title_page: string
  button_label: string
  questions: SweepAccountsAboutQuestion[]
}

export type SweepAccountsAboutExperimentPayload = {
  title_page?: string
  button_label?: string
  questions?: SweepAccountsAboutQuestion[]
  ignore_default_content?: boolean
}

export const defaultSweepAccountsAboutContent: SweepAccountsAboutContent = {
  title_page: 'Entenda mais sobre como o seu saldo rende',
  button_label: 'Entendi',
  questions: [
    {
      title: 'O que é o rendimento no saldo?',
      description:
        'É o valor líquido de rendimentos sobre o dinheiro parado na sua conta, já descontado dos impostos. O saldo é investido em um Certificado de Depósito Bancário (CDB) pela Stone e gera rendimentos automaticamente.',
      type: 'cdb'
    },
    {
      title: 'O que é o rendimento no saldo?',
      description:
        'É o valor líquido de rendimentos sobre o dinheiro parado na sua conta, já descontado dos impostos. O saldo é investido em um Recibo de Depósito Bancário (RDB) pela Stone e gera rendimentos automaticamente.',
      type: 'rdb'
    },
    {
      title: 'O que é um CDB?',
      description:
        'A sigla significa Certificado de Depósito Bancário. É um investimento em que você empresta dinheiro para a instituição e recebe juros em troca. A operação é protegida pelo Fundo Garantidor de Créditos (FGC).',
      type: 'cdb'
    },
    {
      title: 'O que é um RDB?',
      description:
        'A sigla significa Certificado de Depósito Bancário. É um investimento em que você empresta dinheiro para a instituição e recebe juros em troca. A operação é protegida pelo Fundo Garantidor de Créditos (FGC).',
      type: 'rdb'
    },
    {
      title: 'O que é o CDI?',
      description:
        'O Certificado de Depósito Interbancário (CDI) é uma taxa de juros utilizada como referência no mercado financeiro brasileiro. Ele é usado como base para o rendimento de diversos investimentos, como CDBs, fundos de investimento e títulos públicos.',
      type: 'cdb'
    },
    {
      title: 'O que é o CDI?',
      description:
        'O Certificado de Depósito Interbancário (CDI) é uma taxa de juros utilizada como referência no mercado financeiro brasileiro. Ele é usado como base para o rendimento de diversos investimentos, como RDBs, fundos de investimento e títulos públicos.',
      type: 'rdb'
    }
  ]
}

export const defaultSweepAccountsAboutExperimentPayload: ExperimentValue<SweepAccountsAboutExperimentPayload> = {
  value: 'control',
  payload: defaultSweepAccountsAboutContent
}
